import { ChangeEvent, useContext } from 'react';

import SchemaDetailContext from '@atom/components/schemaDetail/SchemaDetailContext';
import { RadioGroup, Switch } from '@atom/mui';
import {
  SchemaBudget,
  StartEndReadingOption,
  StockBasedOption,
} from '@atom/types/schema';

import classes from './costDetail.module.css';

const { RadioButton } = RadioGroup;

interface Props {
  budget: SchemaBudget;
  setBudget: (budget: SchemaBudget) => void;
  updateBudget: (budget: SchemaBudget) => void;
}

const ReadingsSection = ({ budget, setBudget, updateBudget }: Props) => {
  const { schemaTree } = useContext(SchemaDetailContext);

  const { startEndReadingOption, stockBasedOption } = budget;

  const updateStartEndReadingOption = (option: StartEndReadingOption) => {
    const updatedBudget = {
      ...budget,
      startEndReadingOption: option,
    };

    setBudget(updatedBudget);
    updateBudget(updatedBudget);
  };

  const handleToggle = () => {
    const option =
      startEndReadingOption === StartEndReadingOption.NONE
        ? StartEndReadingOption.START_END_READING
        : StartEndReadingOption.NONE;

    const updatedBudget = {
      ...budget,
      startEndReadingOption: option,
    };

    setBudget(updatedBudget);
    updateBudget(updatedBudget);
  };

  const isStockBased =
    stockBasedOption === StockBasedOption.STOCK_BASED ||
    stockBasedOption === StockBasedOption.STOCK_BASED_OPTIONAL;

  const toggled =
    !isStockBased &&
    (startEndReadingOption === StartEndReadingOption.START_END_READING ||
      startEndReadingOption ===
        StartEndReadingOption.START_END_READING_OPTIONAL);

  const isDisabled = schemaTree.isPublished || isStockBased;

  const label = isStockBased ? (
    <div className={classes.readingsContainer}>
      <div className={classes.readingsBold}>Enable Start and End Readings</div>
      <div className={classes.readingsSubtext}>
        Not supported for&nbsp;
        <span className={classes.readingsBold}>Stock-based Inventory</span>
      </div>
    </div>
  ) : (
    'Enable Start and End Readings'
  );

  return (
    <div className={classes.costContainer}>
      <Switch
        checked={toggled}
        onChange={handleToggle}
        label={label}
        disabled={isDisabled}
      />
      {toggled && (
        <RadioGroup
          value={startEndReadingOption}
          onChange={(event: ChangeEvent<HTMLInputElement>) =>
            updateStartEndReadingOption(
              event.target.value as StartEndReadingOption,
            )
          }
        >
          <RadioButton
            value={StartEndReadingOption.START_END_READING}
            label="Default"
            disabled={isDisabled}
          />
          <div className={classes.optionSubtext}>
            Enable for all inventory items of this type.
          </div>
          <RadioButton
            value={StartEndReadingOption.START_END_READING_OPTIONAL}
            label="Optional"
            disabled={isDisabled}
          />
          <div className={classes.optionSubtext}>
            Enable at the individual inventory item level.
          </div>
        </RadioGroup>
      )}
    </div>
  );
};

export default ReadingsSection;
